import React from 'react'

export const WorkStyleRecommendationMessage: React.FC = () => (
  // TODO tailwindcssに移行し切ったら、id属性を削除する
  // TODO v2->v4にアップデートしたら、style属性を削除しcustom-value `px-[5.5px]` を採用する(参考: https://tailwindcss.com/docs/margin#using-a-custom-value)
  <div id="work-style-recommendation-message" className="bg-tech-silver-10 py-1 mb-XS text-gray-800 text-sm text-left leading-6" style={{ paddingLeft: '5.5px', paddingRight: '5.5px' }}>
    <strong className="text-tech-red-100 font-bold">一部リモート・常駐</strong>までご検討いただけると紹介できる案件が<strong className="text-tech-red-100 font-bold">最大約1.7倍</strong>になります！
  </div>
)
